<template>
  <div m-0 p-0 class="access-denied">
    <div class="border">
      <div class="content">
        <h2>Acesso Negado</h2>

        <div class="text">
          <v-icon>mood_bad</v-icon>
          <p>Desculpe, parece que você não tem acesso a esta página.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
   .access-denied{
     height: 80vh;
     width: 100%;
     text-align: center;
     padding-top: calc((80vh - 160px)/2);
   }

  .border {
    background: #00acc2;
    padding: 2px;
    max-width: 600px;
    margin: 0 auto;
  }

  .content {
    background: #fff;
    text-align: center;
    width: 100%;
    height: 100%;
    padding: 10px 0;
  }

  .content h2{
    color: #cc5c38;
    font-size: 2.5em;
  }

  .text{
    text-align: center;
  }

  .text i{
    font-size: 2.5em;
    color: #cc5c38;
    margin: 10px 0;
  }

  .text p{
    font-size: 1.5em;
    color: #444;
  }
</style>

<script>
/* eslint-disable */
// ESLINT desabilitado para ser possível a verificação somente por valor em -> (parseInt(this.company) != this.$auth.user().company_id)
  export default {
    data () {
      return {
        confirmLoading: false,
        dialog: false,
        name: '',
        id: '',
        company: ''
      }
    },
    created () {
      var values = atob(this.$route.params.data).split('|')
      this.name = values[0]
      this.id = values[1]
      this.company = values[2]
      this.$store.commit('loader/change_dialog', true)
      // Se a empresa logada for diferente da empresa que veio na notificação, pergunta ao usuário se ele quer trocar de empresa.
      if (Number.isInteger(parseInt(this.company)) && (parseInt(this.company) != this.$auth.user().company_id)) {
        this.$http.get(`api/has_user_company/${parseInt(this.company)}`).then(res => {
          this.$store.commit('loader/change_dialog', false)
          if (parseInt(res.body) == 1) {
            this.dialog = true
          } else {
            this.$store.commit('snackbar/change_values', {
              text: 'Não foi possível redirecionar.', color: 'warning', dialog: true, timeout: 5000
            })
            this.$router.push(`/home`)
          }
        })
      } else {
        // Se não, somente redireciona ele para a tela da notificação.
        this.$router.push(`/${this.name}/${this.id}`)
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/AccessDenied.vue